import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { APIs } from '../config/api.constant';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  constructor(private apiService: ApiService) { }

  updateContact(data) {
    return this.apiService.post(APIs.addUpdateContact, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getContact() {
    let locationId = localStorage.getItem("locationId") ?? 1;
    return this.apiService.get(APIs.getContactInfo + '?locationId=' + locationId).pipe(
      map((response) => {
        return response ? response : null;
      })
    );
  }
}
